import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics, isSupported } from "firebase/analytics";

// Firebase configuration using environment variables
const firebaseConfig = {
  apiKey:
    import.meta.env.VITE_FIREBASE_API_KEY ||
    "AIzaSyBqJxKzjMxQzQzQzQzQzQzQzQzQzQzQzQz",
  authDomain:
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "orindra-demo.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "orindra-demo",
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "orindra-demo.appspot.com",
  messagingSenderId:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "123456789012",
  appId:
    import.meta.env.VITE_FIREBASE_APP_ID ||
    "1:123456789012:web:abcdefghijklmnopqr",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Analytics (only if supported)
export const analytics = isSupported().then((yes) =>
  yes ? getAnalytics(app) : null
);

export default app;
